import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { COOKIE_CONFIG } from '@app/core/models/cookie-consent.constant';
import { WINDOW } from '@ng-web-apis/common';
import {  NgcCookieConsentService } from 'ngx-cookieconsent';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Inject(WINDOW) private window: Window,
    private readonly injector: Injector,
  ) {}

  loadConfig() {
    if (isPlatformBrowser(this.platformId)) {
      const ccService = this.injector.get(NgcCookieConsentService);
      const cookieConfig = {...COOKIE_CONFIG, cookie:{domain:this.window.location.hostname}};
      //Destroy the previous instance so the cookieservices won't overlap
      ccService.destroy();
      ccService.init(cookieConfig);
    }
  }

}
